import { ReviewImpressionTrackingInfo } from "@omni/types/components/tracking/tracking-info/impression/reviewImpression.trackingInfo";

import { EnrichedAnalyticsEvent } from "@/utils/analytics/analytics.types";

export const getBazaarvoiceImpression = (
    data: EnrichedAnalyticsEvent<ReviewImpressionTrackingInfo>
) => {
    const eventData = data.payload.eventData;

    const impressionData: BV.ImpressionData = {
        bvProduct: "RatingsAndReviews",
        contentId: eventData.contentId,
        productId: eventData.productId,
        brand: eventData.brand,
        categoryId: eventData.categoryId,
        contentType: "review"
    };

    return impressionData;
};
